import { catchError, filter, switchMap } from 'rxjs/operators';
import { KpiEnum } from './../interfaces/kpi.enum';
import { SharedService } from '../shared/shared.service';
import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  NavigationStart,
  CanDeactivate,
  UrlTree,
} from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KpiResolver implements Resolve<boolean> {
  constructor(private sharedService: SharedService, private router: Router) {}
  isErrorPath = false;
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    switch (state.url) {
      case '/somethingWentWrong' || '/phoneNotVerified' || '/notFoundError': {
        return this.sharedService
          .sendKpiTrackingData(KpiEnum.LEAD_MODAL_WINDOW)
          .pipe(
            catchError(() => {
              return of(true);
            })
          );
      }
    }
  }
}
